import { Component, Input } from '@angular/core';
import { CloudPimProductFieldsComponent } from '../cloud-pim-product-fields/cloud-pim-product-fields.component';

export interface GroupedDetails {
  groupId: string;
  groupName: string;
  items: { title: string; value: string; type?: string }[];
  collapsed?: boolean;
}

@Component({
  selector: 'lib-gung-accordion-pim-data-templates',
  templateUrl: './gung-accordion-pim-data-templates.component.html',
  styleUrl: './gung-accordion-pim-data-templates.component.scss',
  standalone: false
})
export class GungAccordionPimDataTemplatesComponent extends CloudPimProductFieldsComponent {
  @Input()
  extraProperties?: GroupedDetails[];

  @Input() collapsedGroupIds?: string[] = [];

  @Input()
  public isColapsed = false;

  groupedProductDetails: GroupedDetails[] = [];

  initTemplate() {
    super.initTemplate();
    this.groupedProductDetails = this.groupByGroupId(this.productDetailsTable);
  }

  groupByGroupId(rows: any[] = []): GroupedDetails[] {
    const groups: GroupedDetails[] = [];

    for (const row of rows) {
      const id = row?.groupId ?? 'default';
      let group = groups.find(g => g.groupId === id);
      if (!group) {
        group = { groupId: id, groupName: this.metadataService.getMetadataValue('productTemplateGroups', 'description', id), items: [] };

        if (this.isColapsed) {
          group.collapsed = this.isColapsed;
        } else if (this.collapsedGroupIds?.includes(group.groupId)) {
          group.collapsed = true;
        }

        groups.push(group);
      }
      group.items.push(row);
    }

    if (!!this.extraProperties) {
      for (const extra of this.extraProperties) {
        groups.push(extra);
      }
    }

    return groups;
  }
}
